/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionsControllerRemoveMutationResponse, TemplateQuestionsControllerRemovePathParams, TemplateQuestionsControllerRemove401, TemplateQuestionsControllerRemove403, TemplateQuestionsControllerRemove404 } from "../../models/checklistsController/TemplateQuestionsControllerRemove";

function getTemplateQuestionsControllerRemoveUrl(id: TemplateQuestionsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-template-questions/${id}` as const }  
  return res
}

/**
 * @summary Soft delete a checklist template question and cascade soft-delete its sub-questions and prompts
 * {@link /api/v1/checklist-template-questions/:id}
 */
export async function templateQuestionsControllerRemove(id: TemplateQuestionsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionsControllerRemoveMutationResponse, ResponseErrorConfig<TemplateQuestionsControllerRemove401 | TemplateQuestionsControllerRemove403 | TemplateQuestionsControllerRemove404>, unknown>({ method : "DELETE", url : getTemplateQuestionsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}